import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthStoreService } from '@core/auth/auth-store.service';

export const authGuard: CanMatchFn = (): Observable<
  boolean | UrlTree | RedirectCommand
> => {
  const authStoreService = inject(AuthStoreService);

  return authStoreService.initAuthInProgress$.pipe(
    filter((inProgress) => !inProgress), // wait until auth is done
    switchMap(() => {
      return authStoreService.$isAuthenticated()
        ? of(true)
        : of(authStoreService.handleUnauthorizedRoute());
    })
  );
};
